"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceholderTextCell = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LayoutStyles_1 = require("../../style/LayoutStyles");
const CellStyles_1 = require("./CellStyles");
const PlaceholderTextCellContainer = (0, vizportalclient_common_components_1.divWithStyle)('PlaceholderTextCell', [LayoutStyles_1.elideTextStyle, CellStyles_1.cellPaddingStyle, {
        fontStyle: 'italic',
        color: widgets_1.TabStyles.Typography.Color.Secondary,
    }]);
const noPadding = {
    paddingLeft: 0,
};
function PlaceholderTextCell(props) {
    return (react_1.default.createElement(PlaceholderTextCellContainer, { title: props.placeholderText, style: props.noPadding ? noPadding : undefined }, props.placeholderText));
}
exports.PlaceholderTextCell = PlaceholderTextCell;
//# sourceMappingURL=PlaceholderTextCell.js.map